import * as React from "react";
import { Else, If, Then } from "react-if";

const ListNoData: React.FC<{ message?: string; loading?: boolean }> = ({
  message,
  loading,
}) => {
  const noDataMessage = message || "No Data Found";
  return (
    <div className="k-nodata">
      <If condition={loading}>
        <Then>Loading ...</Then>
        <Else>
          <div style={{ minWidth: 150 }}>
            <h4 style={{ fontSize: "1em" }}>
              <span
                className="k-icon k-font-icon k-i-warning"
                style={{ fontSize: "2.5em" }}
              />
              <br />
              {noDataMessage}
            </h4>
          </div>
        </Else>
      </If>
    </div>
  );
};

export default ListNoData;
